import { normalize } from '../core/utils'

export const shouldConsiderAsEmployed = (situation: string) => {
    const s = normalize(situation)
    switch (s) {
        case 'full time permanent':
        case 'self employed':
        case 'part time':
        case 'agency':
        case 'temporary':
        case 'armed forces':
        case 'other':
            return true
        case 'disability':
        case 'not employed':
        case 'student':
        case 'retired':
        case 'sub contractor':
        case 'homemaker':
        case 'carer':
            return false
        default:
            return true
    }
}

export const mapEmploymentHistoryDefault = (answers: Record<string, any>) => {
    const current = answers.employmentHistory?.entries['1']
    const residentialTown = answers.addressHistory.entries['1'].addressDetails.town
    const employed = shouldConsiderAsEmployed(current.employmentSituation)

    const baseEmployerDetails = current.employerDetails ?? {}

    const next = {
        ...current,
        ...(employed && residentialTown
            ? { employerDetails: { ...baseEmployerDetails, location: residentialTown } }
            : {}),
        lengthOfTime: { years: '2', months: '0' }
    }

    return { entries: { '1': next } }
}

export type EmploymentOptions = {
    companyNameUnknown?: boolean
    jobTitleUnknown?: boolean
    forceYears?: string
    forceMonths?: string
}

// - defaults employers town to current residential town
// - returns only current employment
export const mapEmploymentHistoryEmployedWithTown = (
    answers: Record<string, any>,
    opts?: EmploymentOptions
) => {
    const current = answers.employmentHistory?.entries['1']
    const residentialTown = answers.addressHistory.entries['1'].addressDetails.town
    const employed = shouldConsiderAsEmployed(current.employmentSituation)

    const forceYears = opts?.forceYears ?? '2'
    const forceMonths = opts?.forceMonths ?? '0'

    const nextEmployerDetails = employed
        ? {
            ...current.employerDetails,
            ...(opts?.jobTitleUnknown ? { jobTitle: 'UNKNOWN' } : {}),
            ...(opts?.companyNameUnknown ? { companyName: 'UNKNOWN' } : {}),
            location: residentialTown
        }
        : current.employerDetails

    const next = {
        ...current,
        ...(employed ? { employerDetails: nextEmployerDetails } : {}),
        lengthOfTime: { years: forceYears, months: forceMonths }
    }

    return { entries: { '1': next } }
}
